module.exports = __webpack_public_path__ + "static/media/leaderboard.d51ee3b3.png";